import React from 'react';

/**
 * WunderGuide sparkle glyph — exact SVG from the RN bundle
 * (`apps/WunderGuide/assets/images/wg-sparkle.svg`). Used as the listening
 * icon, the connecting spinner, and the bot-working particle.
 */
const WgSparkle: React.FC<{
  size?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}> = ({ size = 64, color = '#fff', className, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    aria-hidden
  >
    <path
      fill={color}
      d="M509.4,336.2c-10.1,45.2-13.7,102.5-50.7,134.8-33.6,29.3-83,28.3-124.2,38.2,40.2,7.9,100.6,10.1,131,40.8,31.4,31.7,34.3,98.5,44.5,139.9,13.1-44.5,11.5-97.9,43.5-134.7,31.6-36.4,87.2-38.4,131.5-44.5,1.6-.2,3.2-.1,3.6-2.1-52.8-11.3-116.6-12.3-147.1-64-18.5-31.3-22.8-74.8-30-109.9l-2.2,1.5Z"
    />
  </svg>
);

export default WgSparkle;
